// Copy central do agente GPH (pt-BR).
// Mantido fora do i18n.js por escopo controlado do agente; migrar para i18n quando
// a experiência for expandida para en-US/es-ES.

export const SUPPORT_COMMUNITY_URL = 'https://chat.whatsapp.com/JLkDmYHJL7BBDo2vus8YZc';

export const GPH_COPY = {
  appName: 'Game Pro Hub',
  inputPlaceholder: 'Descreva sua dor no jogo...',
  welcome: 'Me diga o que está te atrapalhando no jogo. Pode ser mira, spray, sensibilidade, treino ou vídeo. Eu conduzo o resto.',

  outOfScope:
    'Eu sou focada em FPS Mobile. Me diga o que está te atrapalhando no jogo: mira, sensibilidade, treino, movimentação ou análise de gameplay.',

  missingContext:
    'Entendi parcialmente, mas preciso saber o que você quer descobrir para montar a análise certa.',

  videoNoContext:
    'Recebi seu vídeo. Antes de analisar, preciso entender o que você quer descobrir nele.',

  freeLimitReached:
    'Que pena! Seu uso free para essa skill acabou. Torne-se Pro e tenha todas as skills da Mi para você usar e evoluir.',

  proOnlySkill:
    'Essa skill é exclusiva do Pro. Torne-se Pro e tenha todas as skills da Mi para usar e evoluir.',

  codmUnavailable:
    'Cálculo de miras para esse jogo ainda não está disponível. Posso te ajudar com diagnóstico, treino ou análise de vídeo.',

  restrictedArea:
    'Área restrita. Posso te ajudar com seu plano, configurações ou suporte.',

  conversationLimitFree:
    'Você atingiu o limite desta conversa no plano Free. Para manter a Mi rápida, preciso iniciar uma nova conversa. Esta conversa será encerrada e você poderá começar outro problema.',
 
  conversationLimitPro:
    'Esta conversa chegou ao limite seguro de contexto. Para manter a Mi rápida e precisa, vamos iniciar uma nova conversa. Seu histórico Pro continuará salvo.',

  errorRecovery:
    'Algo não saiu como esperado. Podemos tentar de novo ou começar outro problema.',

  loginRequired:
    'Você precisa estar logado para usar essa skill.',

  startNewConversation: 'Começar nova conversa',
  startAnotherProblem: 'Começar outro problema',
  subscribePro: 'Assinar Pro',
  seeAnnualPlan: 'Ver plano anual',
  backToConversation: 'Voltar para a conversa',

  // ── Conversa natural da Mi (coach direta, leve, sem cara de sistema) ──
  greetingDefault:
    'Oi. Me diga o que você quer melhorar no jogo hoje. Pode escrever do seu jeito: mira subindo, spray ruim, cálculo de mira, treino ou vídeo.',
  greetingWithGame: (gameLabel) =>
    `Oi. Bora evoluir no ${gameLabel}? Me diga o que está te atrapalhando: mira, spray, treino ou vídeo. Pode escrever do seu jeito.`,
  identityAnswer:
    'Eu sou a Mi, a IA coach do Game Pro Hub.\n\nEu te ajudo a melhorar no FPS Mobile com sensibilidade, cálculo de miras, treino guiado e análise de gameplay.\n\nMe fala o que está te atrapalhando agora: mira, spray, movimentação, x1 ou configuração.',
  generalHelpFps:
    'Posso te ajudar com mira, sensibilidade, treino, movimentação e análise de gameplay. Me conta o que está te atrapalhando no jogo — pode escrever do seu jeito.',
  fpsClarify:
    'Consigo te orientar por treino e diagnóstico. Me descreve melhor o que acontece no jogo: é mira, movimentação, decisão ou sensibilidade?',
  lowIntent:
    'Posso te ajudar com mira, sensibilidade, treino, movimentação e análise de gameplay. Me conta o que está te atrapalhando no jogo — pode escrever do seu jeito.',
  askCapabilities:
    'Eu diagnostico sensibilidade, gero treinos práticos, analiso vídeos de gameplay, calculo miras e cuido do seu plano. Me fala o que está te atrapalhando agora.',
  outOfScopeStrict:
    'Eu sou focada em FPS Mobile, então não vou entrar nesse assunto. Posso te ajudar com mira, sensibilidade, treino, movimentação ou análise de gameplay.',
  videoRequired:
    'Para validar com vídeo, envie um clipe curto mostrando exatamente essa situação.',
  videoAskUpload:
    'Me envie o vídeo e me diga o que você quer que eu avalie: mira, spray, movimentação, tomada de decisão ou sensibilidade.',
  videoReceivedNoContext:
    'Recebi o vídeo. O que você quer que eu avalie nele?',
  gamePreferenceSet: (gameLabel) =>
    `Anotado. Seu foco agora é ${gameLabel}. O que você quer melhorar?`,
  memorySaved:
    'Anotado. Vou considerar isso nos próximos treinos e diagnósticos.',
  researchUnavailable:
    'Essa resposta depende de informação atual que não consegui pesquisar agora. Vou te orientar com base no que sei, mas recomendo validar se houver mudança de patch recente.',
  noSupportVideoFound:
    'Não encontrei um vídeo específico o suficiente para este treino. Posso te entregar o treino agora, mas não vou inventar link.',
  fallbackExpertNotice:
    'Consigo te orientar por treino e diagnóstico enquanto conduzo seu jogo.',
  uncertaintyLow:
    'Não tenho evidência suficiente para afirmar isso com precisão.',
  uncertaintyPatch:
    'Essa resposta depende do patch/meta atual. Preciso pesquisar antes de te entregar uma resposta confiável.',
  videoInsufficient:
    'O vídeo não mostra a situação que precisamos validar. Envie um clipe mostrando exatamente esse cenário.',
  videoFailed:
    'A análise do vídeo falhou. Não vou inventar um resultado — tente enviar novamente.',

  quickIntents: [
    { id: 'qi_aim_bad', label: 'Minha mira está ruim', text: 'Minha mira está ruim' },
    { id: 'qi_calc', label: 'Quero calcular minhas miras', text: 'Quero calcular minhas miras' },
    { id: 'qi_training', label: 'Quero treinar uma jogada', text: 'Quero treinar uma jogada' },
    { id: 'qi_video', label: 'Quero analisar um vídeo', text: 'Quero analisar um vídeo' },
    { id: 'qi_pro', label: 'Quero assinar Pro', text: 'Quero assinar Pro' },
    { id: 'qi_settings', label: 'Quero ver configurações', text: 'Quero ver configurações' },
    { id: 'qi_favorites', label: 'Quero ver meus favoritos', text: 'Quero ver meus favoritos' }
  ]
};

export default GPH_COPY;
